import React, { Component, Fragment } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Spinner,
  Modal, ModalHeader,
  ModalBody, ModalFooter,
  Tooltip
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Colxx } from '../../components/common/CustomBootstrap';
import IntlMessages from '../../helpers/IntlMessages';
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import PasswordStrengthBar from 'react-password-strength-bar';
import {
  postAPI_ResetPassword,
  postAPI_VerifyForgotPassword,
} from '../../constants/APIs';
import aiva_logo from '../../assets/aiva_logo.png';
import { NotificationManager } from '../../components/common/react-notifications';
import queryString from 'query-string';
export default class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      reason: 'ForgotFlow',
      password: '',
      creator: 'user',
      formShow: true,
      loginbutton: false,
      loading: false,
      process: false,
      isShow: false,      
      tooltip: false,
      confirmPassword: '',
      message: '',
    };
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);    
    let data = { data: values.data };
    //  let data = { data: '0NiGF6C1xZBMmcBKNYAHS9BIj0xiavhLqxcVIc171ZcbW/SGhZ9WJLfc/YArjeWrdscqFBgUETavWKanZLfsafTGEpkq+oSRYzCUvAFxDZ+tT+NGk2o+NFCIY1BzH3/p+aGb9HAOwiew35OUMR+Fyw==' };
    AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_VerifyForgotPassword}`,
      data: data,
    }).then(
      (res) => {
        this.setState({ id: res.data.id });
      },
      (error) => {
        console.log('eee.data', error.data);
      }
    );
  }

  handleChangePassword = (password) => {
    this.setState({
      password: password.target.value,
    });
  };

  onUserResetPassword() {
    var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
    if (this.state.password.length >= 12 && this.state.password.length <= 16 &&
      /(?=.*[A-Z])/.test(this.state.password) && /(?=.*[a-z])/.test(this.state.password) &&
      /(?=.*[0-9])/.test(this.state.password) && /(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(this.state.password)) {
      if (this.state.password !== this.state.confirmPassword) {
        this.setState({ message: 'Password and confirm password are not matched.' });
        this.setState({ isShow: true });
      } else {
        this.setState({ process: true, loading: true });
        let data = {
          reason: 'ForgotFlow',
          password: this.state.password,
          creator: 'user',
        };

        AxiosPublicAPI({
          method: 'put',
          url: `${postAPI_ResetPassword}/${this.state.id}/change-password`,
          data: data,
        }).then(
          (res) => {
            this.setState({
              formShow: false,
              loginbutton: true,
            });
            // NotificationManager.success(
            //   'Password Reset Successfully',
            //   'Password Reset Success',
            //   3000,
            //   null,
            //   null,
            //   'success'
            // );
            this.setState({ loading: false });
          },
          (error) => {
            console.log('eee.data', error.data);
          }
        );
      }
    }
    else {
      this.setState({ message: 'Password length must be in between of 12 to 16 character and its must have atleast 1 upper case, 1 lower case, 1 digit and 1 special character.' });
      this.setState({ isShow: true });
    }
  }
  onGoLogin() {
    window.location.href = 'https://app.getaiva.com';
  }
  
  handleChangeConfirmPassword = password => {
    this.setState({
      confirmPassword: password.target.value,
    });
  };

  render() {
    return (
      <Fragment>
        <Row className="h-100">
          <Colxx xxs="12" md="10" className="mx-auto my-auto">
            <Card className="auth-card">
              <div className="position-relative image-side ">
                <p className="text-white h2">
                  a voucher distribution system for savvy tourism businesses
                </p>
                <p className="white mb-0">Please enter the new password.</p>
              </div>
              <div className="form-side">
                {!this.state.process && (
                  <Fragment>
                    <NavLink to={`/`} className="white">
                      <span class="logo-single">
                        {' '}
                        <img
                          src={aiva_logo}
                          width="150"
                        />{' '}
                      </span>
                    </NavLink>
                    <CardTitle
                      className="mb-4"
                      style={{ display: this.state.formShow ? 'block' : 'none' }}
                    >
                      Reset Password
                    </CardTitle>
                    <div className='m-2'>
                       <h6>Your password must contain </h6>
                       <ul className='ml-3'>
                        <li className='mb-2'>Atleast 12 Characters (16 Maximum).</li>
                        <li className='mb-2'>Atleast one upper case letter.</li>
                        <li className='mb-2'>Atleast one lower case letter.</li>
                        <li className='mb-2'>Atleast one number.</li>
                        <li className='mb-2'>Atleast one of the following symbols (?=.*[@#$%^&-+=()]).</li>
                       </ul>                       
                    </div>                    
                    <Form
                      style={{ display: this.state.formShow ? 'block' : 'none' }}
                    >
                      <Label className="form-group has-float-label" id="Tooltip">
                        <Input type="password" onChange={this.handleChangePassword} />
                        <IntlMessages id="user.newpassword" />
                      </Label>
                      <Tooltip
                        placement={'right'}
                        isOpen={this.state.tooltip}
                        target={"Tooltip"}
                        toggle= {()=>this.setState(prevState => ({
                          tooltip: !prevState.tooltip
                        }))}
                      >
                        <p className='text-start' style={{color:`${(this.state.password.length >=12 && this.state.password.length <=16)?'green':'red'}`}}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Be 12 to 16 characters long</span></p>
                        <p className='text-start' style={{color:`${/(?=.*[A-Z])/.test(this.state.password)?'green':'red'}`}}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one upper case character</span></p>
                        <p className='text-start' style={{color:`${/(?=.*[a-z])/.test(this.state.password)?'green':'red'}`}}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one lower case character</span></p>
                        <p className='text-start' style={{color:`${/(?=.*[0-9])/.test(this.state.password)?'green':'red'}`}}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one number</span></p>
                        <p className='text-start' style={{color:`${/(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(this.state.password)?'green':'red'}`}}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one special character</span></p>                        
                      </Tooltip>
                      {this.state.password !== '' && <div className=""><PasswordStrengthBar minLength={12}
                        password={this.state.password}></PasswordStrengthBar>
                      </div>}
                      <Label className="form-group has-float-label my-4">
                        <Input type="password" id="password" onChange={this.handleChangeConfirmPassword} />
                        <IntlMessages id="user.newpasswordagain" />
                      </Label>                     
                      <div className="d-flex justify-content-end align-items-center">
                        <Button
                          color="primary"
                          className="text-white"
                          size="lg"
                          onClick={() => this.onUserResetPassword()}
                        >
                          <IntlMessages id="user.reset-password-button" />
                        </Button>
                      </div>
                    </Form>
                  </Fragment>
                )}
                {this.state.process &&
                  (this.state.loading ? (
                    <div className="text-center">
                      <Spinner color="primary" className="mb-1" />
                      <p>Your request is in progress</p>
                    </div>
                  ) : (
                    <div className="text-center">
                      <h2 className="mb-5">Password successfully reset</h2>
                      <p className="mb-2">
                        You have successfully reset your password
                      </p>
                      <a>
                        {' '}
                        <div
                          className="text-primary text-small font-weight-medium d-none d-sm-block"
                          onClick={() => this.onGoLogin()}
                        >
                          Return to log in screen
                        </div>{' '}
                      </a>
                    </div>
                  ))}
                {/* {this.state.loginbutton === true && (
                <Form>
                  <Button
                    onClick={() => this.onGoLogin()}
                    color="primary"
                    size="lg"
                    className="btn-shadow"
                  >
                    <IntlMessages id="user.login-button" />
                  </Button>
                </Form>
              )} */}
              </div>
            </Card>
          </Colxx>
        </Row>
        <Modal isOpen={this.state.isShow} toggle={() => this.setState({ isShow: !this.state.isShow })}>
          <ModalHeader toggle={() => this.setState({ isShow: !this.state.isShow })}>
            Password
          </ModalHeader>
          <ModalBody>
            <h6 className="m--2">{this.state.message}</h6>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.setState({ isShow: !this.state.isShow })}>Close</Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}
